import { useState } from "react";
import slide1 from "../images/image-slide-1.jpg";
import slide2 from "../images/image-slide-2.jpg";
import slide3 from "../images/image-slide-3.jpg";
import slide4 from "../images/image-slide-4.jpg";
import slide5 from "../images/image-slide-5.jpg";
import previous from "../images/icon-arrow-left.svg";
import next from "../images/icon-arrow-right.svg";

const Work = () => {
	const photos = [slide1, slide2, slide3, slide4, slide5];
	const [photo, setPhoto] = useState(2);

	const paginatePhoto = (direction) => {
		if (photo === 0 && direction === -1) {
			// wrap from first to last in response to user selecting previous on first photo
			setPhoto(photos.length - 1);
		} else if (photo === photos.length - 1 && direction === 1) {
			// wrap from last to first in response to user selecting next on last photo
			setPhoto(0);
		} else {
			setPhoto(photo + direction);
		}
	};

	return (
		<div className='h-338 md:h-576 mt-32 md:mt-120 xl:mt-88 flex flex-col items-center'>
			<h2 className='mb-32 md:mb-56 font-bold text-24 md:text-32 leading-30 md:leading-40 text-center'>
				My Work
			</h2>

			{/* carousel */}
			<div className='w-840 h-180 md:w-1680 md:h-360 flex items-center justify-between'>
				{/* prev */}
				<div className='w-270 h-180 md:w-540 md:h-360 rounded-10 overflow-hidden'>
					<img
						src={photo === 0 ? photos[photos.length - 1] : photos[photo - 1]}
						alt='previous'
						className='w-270 h-180 md:w-540 md:h-360 rounded-10'
					/>
				</div>
				{/* current */}
				<div className='w-270 h-180 md:w-540 md:h-360 rounded-10 overflow-hidden'>
					<img
						src={photos[photo]}
						alt='current'
						className='w-270 h-180 md:w-540 md:h-360 rounded-10'
					/>
				</div>
				{/* next */}
				<div className='w-270 h-180 md:w-540 md:h-360 rounded-10 overflow-hidden'>
					<img
						src={photo === photos.length - 1 ? photos[0] : photos[photo + 1]}
						alt='next'
						className='w-270 h-180 md:w-540 md:h-360 rounded-10'
					/>
				</div>
			</div>
			{/* selectors */}
			<div className='w-144 h-64 mt-32 flex justify-between'>
				<div
					onClick={() => paginatePhoto(-1)}
					className='w-64 h-64 flex items-center justify-center bg-black hover:bg-galactic_blue hover:cursor-pointer rounded-full'
				>
					<img src={previous} alt='previous' />
				</div>
				<div
					onClick={() => paginatePhoto(1)}
					className='w-64 h-64 flex items-center justify-center bg-black hover:bg-galactic_blue hover:cursor-pointer rounded-full'
				>
					<img src={next} alt='next' />
				</div>
			</div>
		</div>
	);
};

export default Work;
